import React, { useState, useEffect } from 'react';
import debounce from 'lodash/debounce';

export const MediaContext = React.createContext();

function detectMedia(breakpoints, width) {
	return Object.keys(breakpoints).reduce(
		(acc, label) => {
			return {
				...acc,
				isGreaterThan: {
					...acc.isGreaterThan,
					[label]: width >= breakpoints[label],
				},
				isLessThan: {
					...acc.isLessThan,
					[label]: width < breakpoints[label],
				},
			};
		},
		{
			isGreaterThan: {},
			isLessThan: {},
		}
	);
}

export default function MediaContextProvider({
	breakpoints = {
		sm: 0,
		md: 701,
		lg: 961,
		xl: 1701,
	},
	children,
}) {
	const [media, setMedia] = useState(detectMedia(breakpoints, window.innerWidth));

	useEffect(() => {
		const handleWindowResize = debounce(() => {
			setMedia(detectMedia(breakpoints, window.innerWidth));
		}, 200);

		window.addEventListener('resize', handleWindowResize);

		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	}, [JSON.stringify(breakpoints)]);

	return <MediaContext.Provider value={media}>{children}</MediaContext.Provider>;
}
